<template>
<div class="wrapper" style="z-index: 10000;">
    <div class="book_info">
        <a class="close_btn" @click="close"></a>
        <div class="book_intro">
            <div class="book_img"></div>
            <div class="book_content">
                <div class="main_title"></div>
                <div class="sub_title"></div>
                <div class="summary">
                    <div class="left">与概念为友</div>
                    <div class="right">
                        <p>用规则战胜人性用AI做工具</p>
                        <p>用数据做决策9天入门</p>
                        <p>建立一生受用的科学交易体系</p>
                    </div>
                </div>
                <div style="overflow: hidden;">
                    <a class="intro_btn" @click="show = ! show">赠书简介</a>
                </div>
            </div>
        </div>
        <div v-show="show" class="book_detail">
            <p>本书不是“猜涨跌”的书，而是一套用概率战胜人性、用数据建立优势的实战交易体系。作者桥博士集30年交易经验、A1量化前沿、独创「宽论」体系于一书，不讲玄学、不堆术语、不搞虚招，从K线、技术指标到量化模型、A策略、资金风控全覆盖，使普通投资者学会理性下单、科学盈利、长期稳健。全书可回测、可编码、可复现、可检验，是A股市场真正稀缺的零基础一实战-A1量化一站式指南。</p>
            <h4 style="margin-top:20px">内容特色</h4>
            <div style="margin-bottom: 10px;overflow: hidden;">
                <div class="item">概率思维为核心：不赌运气，只做高胜率决策</div>
                <div class="item">全量历史回测：所有方法数据化、可验证、可复制</div>
                <div class="item">9 天 72小时学习地图:零基础快速上手，学完即用</div>
                <div class="item">AI量化落地：从传统技术分析升级AI智能交易</div>
                <div class="item">独创「宽论」体系：大资金实盘验证的交易框架</div>
                <div class="item">风控贯穿全程：轻仓、止损、顺势，守住本金再盈利</div>
            </div>
            <h4>实拍展示</h4>
            <div class="img_box">
                <img src="../assets/image/shu_01.png" alt="">
                <img src="../assets/image/shu_03.png" alt="">
                <img src="../assets/image/shu_05.png" alt="">
                <img src="../assets/image/shu_07.png" alt="">
                <img src="../assets/image/shu_09.png" alt="">
                <img src="../assets/image/shu_11.png" alt="">
            </div>
        </div>
        <div class="btn_box">
            <div class="btn" @click="yes">我需要</div>
            <div class="btn" @click="close">我不需要</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        show: false
    }),
    methods: {
        yes () {
            this.$market.book({
                orderInfo: this.$store.state.Order.submitData,
                orderId: this.$store.state.orderID ,
                closePop: this.close
            })
        },
        close(){
            this.$store.commit('setIsbook', false)
        }
    }
}
</script> 

<style scoped>
.wrapper {
    position: fixed;
    background-color: rgba(0,0,0,0.3);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 10000;
}
.book_info {
    width: 803px;
    border-radius: 10px;
    background: url(../assets/image/book_bg.png) no-repeat top center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 35px 20px 38px;
    box-sizing: border-box;
}
.book_intro {
    display: flex;
}
.book_img {
    /* flex: 1; */
    height: 282px;
    background: url(../assets/image/book_img.png) no-repeat center top;
    width: 216px;
    margin: 0 50px;
}
.book_content {
    flex: 0 400px;
}
.book_content .main_title {
    height: 80px;
    background: url(../assets/image/book_title.png) no-repeat center top;
    margin-top: 10px;
    margin-bottom: 10px;
}
.book_content .sub_title {
    color: #caa365;
    font-size: 22px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    position: relative;
    margin-top: 20px;
    background: url(../assets/image/book_sub_title.png) no-repeat center;
}
.book_content .sub_title::before {
    content: '';
    width: 6px;
    height: 32px;
    position: absolute;
    left: 0;
    top: 0;
    background: url(../assets/image/book_sub_title_bg.png) no-repeat top center;
}
.book_content .sub_title::after {
    content: '';
    width: 6px;
    height: 32px;
    position: absolute;
    right: 0;
    top: 0;
    background: url(../assets/image/book_sub_title_bg.png) no-repeat top center;
}
.book_content .summary {
    width: 395px;
    height: 107px;
    background: url(../assets/image/book_summary_bg.png) no-repeat left center;
    background-size: 100%;
    border: 1px solid #31304f;
    border-radius: 10px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    color: #caa365;
    font-size: 18px;
}
.book_content .summary .left {
    flex: 1;
    /* padding-left: 10px; */
    text-align: center;
}
.book_content .summary .right {
    flex: 0 257px;
    font-size: 17px;
    line-height: 30px;
}
.book_content .summary .right p::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 100%;
    background-color: #caa365;
    vertical-align: middle;
    margin-right: 10px;

}
.intro_btn{
    color: #3c88ff;
    float: right;
    font-size: 15px;
    text-decoration: underline;
    margin-top: 10px;
    margin-right: 2px;
}
.book_detail {
    background-color: #29243a;
    color: #caa365;
    padding: 20px;
    border-radius: 10px;
    font-size: 14px;
    margin-top: 10px;
    overflow: hidden;
}
.book_detail p {
    text-indent: 2em;
}
.book_detail h4 {
    color: #e08d01;
    font-size: 15px;
    padding: 0;
    margin: 10px 0;
}
.book_detail .item {
    float: left;
    width: 50%;
    margin-bottom: 10px;
    background: url(../assets/image/book_item_bg.png) no-repeat left center;
    padding-left: 20px;
    box-sizing: border-box;
}
.img_box img {
    margin-right: 7px;
}
.img_box img:last-child{
    margin-right: 0;
}
.btn_box {
    text-align: center;
    margin-top: 20px;
}
.btn_box .btn {
    display: inline-block;
    width: 118px;
    height: 36px;
    line-height: 36px;
    background: url(../assets/image/book_btn_bg.png) no-repeat center;
    font-size: 20px;
    text-align: center;
    color: #281439;
    margin: 0 20px;
    font-weight: bold;
    cursor: default;
}
.close_btn {
    display: block;
    width: 23px;
    height: 23px;
    position: absolute;
    right: 20px;
    top: 15px;
    background: url(../assets/image/book_close_btn.png) no-repeat center;
    background-size: 100%;
}
</style>